const PREFIX = 'NEWS_CLUSTER_FEED';

export default {
  FETCH_CLUSTER_INFO: `${PREFIX}/FETCH_CLUSTER_INFO`,
  RECEIVE_CLUSTER_INFO_DONE: `${PREFIX}/RECEIVE_CLUSTER_INFO_DONE`,
  RECEIVE_CLUSTER_INFO_FAILURE: `${PREFIX}/RECEIVE_CLUSTER_INFO_FAILURE`,
};
